import { render, staticRenderFns } from "./CategoriesRow.vue?vue&type=template&id=71273150&scoped=true"
import script from "./CategoriesRow.vue?vue&type=script&lang=js"
export * from "./CategoriesRow.vue?vue&type=script&lang=js"
import style0 from "./CategoriesRow.vue?vue&type=style&index=0&id=71273150&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71273150",
  null
  
)

export default component.exports